import { useNavigate, useSearchParams } from 'react-router-dom'
import { SurveyResultsDashboard } from './studentdashboard'
import { useJsonStore } from '../store/json-store'
import { useEffect } from 'react'
import { PageContainer } from '@/component/layout'
import { getLatestSurveyAttempt } from '@/services/survey'
import { useSidebarStore } from '../store/sidebare-store'

interface SurveyResultsWrapperProps {
  userName: string
  studentId: string
}

export const SurveyResultsWrapper = ({ userName, studentId }: SurveyResultsWrapperProps) => {
  const navigate = useNavigate()
  const genericObject = useJsonStore((state) => state.genericObject)
  const [searchParams] = useSearchParams()

  // Try to get surveyId from multiple sources
  const surveyIdFromUrl = searchParams.get('surveyId')
  const surveyIdFromStore = genericObject?.surveyId
  const surveyIdFromLocalStorage = localStorage.getItem('currentSurveyId')

  const surveyId = surveyIdFromUrl || surveyIdFromStore || surveyIdFromLocalStorage

  // Validate surveyId against the API — redirect to intro if no completed attempt found
  useEffect(() => {
    ;(async () => {
      try {
        const attempt = await getLatestSurveyAttempt(studentId)
        if (attempt.surveyId) {
          useSidebarStore.getState().setSidebarState({ surveyResult: true })
        }
      } catch {
        // No completed attempt yet  — only redirect if no cached surveyId
        if (!surveyId) {
          navigate('/student/survey/intro', { replace: true })
        }
      }
    })()
  }, [studentId])

  // Store surveyId in localStorage when available
  useEffect(() => {
    if (surveyId) {
      console.log('survey id found: ', surveyId)
      localStorage.setItem('currentSurveyId', surveyId)
    }
  }, [surveyId])

  if (!surveyId) {
    console.log('survey id not found')

    return (
      <PageContainer>
        <div className='text-center'>
          <p className='text-red-600 mb-4'>Survey ID not found</p>
          <p className='text-gray-600'>Please complete the survey first.</p>
          <button onClick={() => navigate('/student/survey/intro')} className='mt-4 px-4 py-2 bg-[var(--primary)] text-white rounded hover:opacity-90'>
            Return to Survey
          </button>
        </div>
      </PageContainer>
    )
  }

  return <SurveyResultsDashboard userName={userName} surveyId={parseInt(surveyId, 10)} />
}
